define([
    "./transitionsModule",
    "text!../extension/AddNewExtension.html",
    "json!../monitoring.json"
], function (module, extensionModalTemplate, monitoring) {
    "use strict";

    return module.service("transitionService", [
        "monitoringService",
        "restrictionConfigurationService",
        "messagesModal",
        "loadingService",
        "mbrService",
        "remoteExceptionHandler",
        "remoteMessageModal",
        "TransitionStatus",
        "FailureType",
        "extensionService",
        "$modal",
        "$http",
        function (monitoringService, restrictionConfigurationService, messagesModal, loadingService, mbrService, remoteExceptionHandler, remoteMessageModal, TransitionStatus, FailureType, extensionService, $modal, $http) {
            var self = this;

            self.isFinalized = function (transition) {
                var transitionStatus = transition.status;
                return transitionStatus === TransitionStatus.FINALIZED ||
                    transitionStatus === TransitionStatus.NOT_ACCOMPLISHED ||
                    transitionStatus === TransitionStatus.PARTIALLY_ACCOMPLISHED ||
                    transitionStatus === TransitionStatus.CANCELLED;
            };

            self.isAttachmentRequired = function () {
                return loadingService(restrictionConfigurationService.find()).then(function (configuration) {
                    return configuration.transitionsRestrictionConfiguration.some(function (restrictionConfiguration) {
                        return restrictionConfiguration.attachmentMandatoryToFinalize && restrictionConfiguration.monitorableType === "br.com.neolog.monitoring.monitorable.model.api.StandardMonitorableType.INVOICE";
                    });
                })
            }


            self.accomplishTransitions = function (ids, timestamp = Date.now(), comment = null) {
                return changeTransitionsStatus(
                    "monitoring.transition.header.finalize.confirmation",
                    ids,
                    TransitionStatus.FINALIZED,
                    timestamp,
                    comment);
            };

            self.notAccomplishTransition = function (id, timestamp, comment, failureReasonId, isTotalSelected, notDeliveredDetails) {
                return loadingService(changeTransitionsStatus(
                    "monitoring.transition.header.notAccomplish.confirmation",
                    [id],
                    TransitionStatus.NOT_ACCOMPLISHED,
                    timestamp || Date.now(),
                    comment,
                    failureReasonId,
                    isTotalSelected,
                    notDeliveredDetails));
            };

            self.notAccomplishTransitions = function (ids, comment, failureReasonId, isTotalSelected, notDeliveredDetails) {
                return changeTransitionsStatus(
                    "monitoring.transition.header.notAccomplish.confirmation",
                    ids,
                    TransitionStatus.NOT_ACCOMPLISHED,
                    Date.now(),
                    comment,
                    failureReasonId,
                    isTotalSelected,
                    notDeliveredDetails);
            };

            self.getTimestampStatus = function (transitionid) {
                return getTimestampStatusService(transitionid);
            }

            function getTimestampStatusService(transitionid) {
                return $http.post(getTimestampStatusServicePath(), transitionid).then(function (response) {
                    return response.data;
                });
            }

            function getTimestampStatusServicePath() {
                return monitoring.baseUrl + monitoring.services.timestampStatus;
            }

            function changeTransitionsStatus(warningMessage, transitionIds, newStatus, timestamp, comment, failureReasonId, isTotalSelected, notDeliveredDetails) {
                return loadingService(monitoringService.findTransitionsById(transitionIds)
                    .catch(remoteExceptionHandler()))
                    .then(function (transitions) {
                        return messagesModal.cancellable("dialog.warning", [{
                            keyBundle: warningMessage,
                            parameters: transitions.map(function (transition) {
                                return transition.sourceId;
                            })
                        }]).then(function () {
                            return transitions;
                        });
                    }).then(function (transitions) {
                        let populatedDeliveryDetails = [];
                        let transitionStatus = newStatus;

                        if (notDeliveredDetails) {
                            populatedDeliveryDetails = convertDetailsToItemsDTO(isTotalSelected, notDeliveredDetails)
                            if (populatedDeliveryDetails.length === 0) {
                                return [{
                                    description: "monitoring.transition.failure.reason.not.delivered.quantity.not.found",
                                    result: false
                                }]
                            }
                            if (isTotalSelected) {
                                transitionStatus = TransitionStatus.NOT_ACCOMPLISHED;
                            } else {
                                // Analisa se todos os items tiveram falha total, mesmo se marcado falha parcial
                                transitionStatus = notDeliveredDetails.every(item => item.failure === null || item.failure === item.total) ?
                                    TransitionStatus.NOT_ACCOMPLISHED : TransitionStatus.PARTIALLY_ACCOMPLISHED;
                            }
                        }

                        const finalizedTransition = transitions.map(function (transition) {
                            return {
                                "transitionId": transition.id,
                                "latitude": null,
                                "longitude": null,
                                "status": transitionStatus,
                                "finalizedTimestamp": timestamp,
                                "completionSource": "FrontEnd",
                                "comment": comment,
                                "failureReasonId": failureReasonId,
                                "notDeliveredItemsDTO": populatedDeliveryDetails
                            };
                        });
                        var data = new FormData();
                        data.append("transitions", new Blob([JSON.stringify(finalizedTransition)], {
                            type: "application/json"
                        }));
                        var files = comment ? comment.files : null;
                        if (files) {
                            Array.prototype.forEach.call(files, function (file) {
                                let encodedFilename = encodeURIComponent(file.name);
                                data.append("attachments", file, encodedFilename);
                            })
                        }
                        return loadingService(mbrService.transitionChangeStatus(data)
                            .catch(remoteExceptionHandler()));
                    }).then(function (remoteMessages) {
                        return remoteMessageModal(remoteMessages);
                    });
            }

            function convertDetailsToItemsDTO(isTotalSelected, notDeliveredDetails) {
                //  falha total
                if (isTotalSelected) {
                    return notDeliveredDetails.map(function (detail) {
                        return getNotDeliveredDetail(detail, detail.total);
                    })
                }
                // falha parcial
                const populatedNotDeliveredDetails = notDeliveredDetails.filter(function (details) {
                    return details.failure !== 0
                })
                if (populatedNotDeliveredDetails.length === 0) {
                    return [];
                }
                return populatedNotDeliveredDetails.map(function (detail) {
                    return getNotDeliveredDetail(detail, detail.failure);
                })
            }

            function getNotDeliveredDetail(detail, failureValue) {
                return {
                    id: detail.id,
                    quantity: getFailureValue(failureValue, 1, detail.failureType, FailureType.FOR_QUANTITY),
                    weight: getFailureValue(failureValue, 0, detail.failureType, FailureType.FOR_WEIGHT),
                    volume: getFailureValue(failureValue, 0, detail.failureType, FailureType.FOR_VOLUME),
                }
            }

            function getFailureValue(failureValue, defaultValue, failureType, expectedFailureType) {
                if (!failureType) {
                    return failureValue
                }
                if (failureType === expectedFailureType) {
                    return failureValue
                }
                return defaultValue;
            }

            self.getTransitionsByMonitorableType = function (monitorableType) {
                return $http.get(monitoring.baseUrl + monitoring.services.transitionsByMonitorableType, {
                    params: {"monitorableType": monitorableType}
                }).then(function (response) {
                    return response.data;
                });
            }

            return self;
        }]);
});